import React from 'react';
import { useLocalSearchParams } from 'expo-router';

import Channel from '@/components/messages/Channel/Channel';

const ChannelScreen = () => {
  const { channelUrl } = useLocalSearchParams();

  if (!channelUrl || typeof channelUrl !== 'string') {
    // TODO(ES-102): handle invalid or missing channelUrl
    return null;
  }

  return <Channel channelUrl={channelUrl} />;
};

export default ChannelScreen;
